import ColorSelector from "./component-library7.mjs";
import Heading from "./component-library6.mjs";
import ToggleButton from "./component-library61.mjs";
import "./component-library189.mjs";
import normalizeComponent from "./component-library82.mjs";
const _sfc_main = {
  name: "ComparisonProduct",
  components: {
    ColorSelector,
    Heading,
    ToggleButton
  },
  props: {
    title: { type: String, required: true },
    headingTag: { type: String, default: "h4" },
    products: { type: Array, required: true },
    productsBig: { type: Array, default: () => [] },
    hasSameHeight: { type: Boolean }
  },
  data() {
    return {
      activeIndex: 0,
      showBigProducts: false,
      currentProducts: this.products
    };
  },
  computed: {
    hasBigProducts() {
      return this.productsBig.length > 0;
    },
    colorVariants() {
      return this.currentProducts.map((product) => ({
        name: product.colorName || product.alt,
        color: {
          code: product.color
        }
      }));
    },
    activeProduct() {
      return this.showBigProducts ? this.productsBig[this.activeIndex] : this.products[this.activeIndex];
    }
  },
  methods: {
    toggleAction(isActive) {
      this.showBigProducts = isActive;
      this.activeIndex = 0;
      this.currentProducts = this.showBigProducts ? this.productsBig : this.products;
    },
    changeImageColor(index) {
      this.activeIndex = index;
    }
  }
};
var _sfc_render = function render() {
  var _vm = this, _c = _vm._self._c;
  return _c("div", { staticClass: "comparison-product" }, [_c("div", { staticClass: "comparison-product__top" }, [_c("Heading", { staticClass: "comparison-product__title", attrs: { "tag": _vm.headingTag, "size": "sm", "font-weight": "ultra" } }, [_vm._v(" " + _vm._s(_vm.title) + " ")]), _c("div", { staticClass: "comparison-product__image" }, [_vm._t("image", null, { "itemCurrent": _vm.activeProduct })], 2)], 1), _c("div", { staticClass: "comparison-product__bottom" }, [_vm.hasBigProducts ? _c("ToggleButton", { staticClass: "comparison-product__toggle", on: { "update:toggle": _vm.toggleAction } }) : _vm._e(), _vm.hasSameHeight && !_vm.hasBigProducts ? _c("div", { staticClass: "comparison-product__toggle-placeholder" }) : _vm._e(), _vm.currentProducts.length > 1 ? _c("ColorSelector", { staticClass: "comparison-product__color", attrs: { "variants": _vm.colorVariants, "value": _vm.activeIndex, "circle": "" }, on: { "input": _vm.changeImageColor } }) : _vm._e()], 1)]);
};
var _sfc_staticRenderFns = [];
var __component__ = /* @__PURE__ */ normalizeComponent(
  _sfc_main,
  _sfc_render,
  _sfc_staticRenderFns,
  false,
  null,
  "06daaf4e",
  null,
  null
);
const comparisonProduct = __component__.exports;
export {
  comparisonProduct as default
};
